import React, { useEffect, useRef, useState } from 'react';
import { animate, useInView, useReducedMotion } from 'framer-motion';
type CountUpProps = {
  to: number;
};

/** Shows the final number by default; counts up once (from ~60%, never zero) when scrolled into view. */
export function CountUp({
  to
}: CountUpProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const inView = useInView(ref, {
    once: true,
    amount: 0.6
  });
  const reduce = useReducedMotion();
  const [value, setValue] = useState(to);
  useEffect(() => {
    if (reduce || !inView) return;
    const controls = animate(Math.round(to * 0.6), to, {
      duration: 1.2,
      ease: [0.23, 1, 0.32, 1],
      onUpdate: v => setValue(Math.round(v))
    });
    return () => controls.stop();
  }, [inView, reduce, to]);
  return <span ref={ref} className="tabular-nums" data-id="element-14" data-mp="rerpo4vyeuk4">
      <span aria-hidden="true" data-id="element-15" data-mp="3pyp1v4dzyj6">{value}</span>
      <span className="sr-only" data-id="element-16" data-mp="3onjbprdsgpf">{to}</span>
    </span>;
}